module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_8019.c3c6cb5c.png";